"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@vueuse/core");
var vue_1 = require("vue");
exports.default = vue_1.defineComponent({
    name: 'TUIMessage',
    props: {
        message: {
            type: String,
            default: '',
        },
        duration: {
            type: Number,
            default: 3000,
        },
        repeatNum: {
            type: Number,
            default: 1,
        },
        id: {
            type: String,
            default: '',
        },
        onClose: {
            type: Function,
            required: false,
        },
        offset: {
            type: Number,
            default: 20,
        },
        zIndex: {
            type: Number,
            default: 0,
        },
        isH5: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: '',
        },
    },
    setup: function (props) {
        var visible = vue_1.ref(false);
        var stopTimer = undefined;
        function startTimer() {
            if (props.duration > 0) {
                (stopTimer = core_1.useTimeoutFn(function () {
                    if (visible.value)
                        close();
                }, props.duration).stop);
            }
        }
        function clearTimer() {
            stopTimer === null || stopTimer === void 0 ? void 0 : stopTimer();
        }
        function close() {
            visible.value = false;
        }
        vue_1.watch(function () { return props.repeatNum; }, function () {
            clearTimer();
            startTimer();
        });
        var customStyle = vue_1.computed(function () { return ({
            top: props.offset + "px",
            zIndex: props.zIndex,
        }); });
        vue_1.onMounted(function () {
            startTimer();
            visible.value = true;
        });
        var handleStyle = function (type) {
            if (type && (type === 'error' || type === 'success' || type === 'warning'))
                return type;
            return 'normal';
        };
        return {
            visible: visible,
            customStyle: customStyle,
            handleStyle: handleStyle,
        };
    },
});
